// extracted by mini-css-extract-plugin
export default {"errorText":"_0aYKV0G1--FieldError_errorText__EAjpC","wiggle":"_0aYKV0G1--FieldError_wiggle__rtgKg","shimmer":"_0aYKV0G1--FieldError_shimmer__jbV1H"};